import { useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';

import { SYMBOL_FOR_EMPTY_CELL, isServiceColumn } from '@/components/AgGrid/helpers';
import { BASE_GRID_OPTIONS } from '@/components/AgGrid/helpers/baseGridOptions';

const useAgGridDocumentsProps = () =>
  // TODO: ag-grid separate SSRM and CSRM props
  useMemo(
    () => ({
      ...BASE_GRID_OPTIONS,
      detailCellRenderer: 'masterViewCellRenderer',
      // this is needed for tooltip,
      // columnHoverHighlight add .ag-column-hover on cell for finding hovered cell
      columnHoverHighlight: true,
      suppressClickEdit: true,
      suppressMaxRenderedRowRestriction: true,
      suppressScrollOnNewData: false,
      suppressColumnMoveAnimation: true,
      suppressMultiSort: true,
      cellSelection: { handle: { mode: 'range' } },
      defaultColDef: {
        pinned: null,
        sortable: true,
        resizable: true,
        enableValue: true,
        minWidth: 100,
        valueFormatter: ({ value, colDef }) => {
          if (isServiceColumn(colDef?.field)) return null;

          return isEmpty(value) ? SYMBOL_FOR_EMPTY_CELL : value;
        },
        cellClassRules: {
          'cell-negative-number': ({ value }) => typeof value === 'number' && value < 0,
        },
      },
      alwaysShowVerticalScroll: true,
      statusBar: {
        statusPanels: [
          {
            statusPanel: 'amountSumStatusPanel',
          },
        ],
      },
      getContextMenuItems: () => ['copy', 'copyWithHeaders', 'paste'],
      getRowStyle: (e) => {
        if (e.node.rowPinned) return { border: 'none' };
        return e.node.detail ? { overflowY: 'auto', backgroundColor: '#fff' } : undefined;
      },
    }),
    [],
  );
export default useAgGridDocumentsProps;
